const initState = {
    isFetching: false,
    fetched: false,
    isError: false,
    isSaving: false,
    saved: false,
    userKeys: [],
    readTime: null,
    lastUpdated: null,
};
export default function userKeys(state = initState, action) {
    switch (action.type) {
        case 'REQUEST_USER_KEYS':
            return {
                ...state,
                [action.code]: {
                    isFetching: true,
                    fetched: false,
                    isError: false,
                },
            };
        case 'RECEIVE_USER_KEYS':
            return {
                ...state,
                isFetching: false,
                fetched: true,
                isError: false,
                userKeys: action.userKeys,
                readTime: action.readTime,
                lastUpdated: action.receivedAt,
            };
        case 'RECEIVE_USER_KEYS_ERROR':
            console.error(action.error);
            return {
                ...state,
                isFetching: false,
                fetched: true,
                isError: true,
                error: action.error.toString(),
            };
        case 'REQUEST_SAVE_USER_KEY':
            return {
                ...state,
                isSaving: true,
                saved: false,
                isError: false,
            };
        case 'RECEIVE_SAVE_USER_KEY':
            return {
                ...state,
                isSaving: false,
                saved: true,
                isError: false,
                key: action.key,
                lastUpdated: action.receivedAt,
            };
        case 'RECEIVE_SAVE_USER_KEY_ERROR':
            console.error(action.error);
            return {
                ...state,
                isSaving: false,
                saved: true,
                isError: true,
                error: action.error.toString(),
            };
        default:
            return state;
    }
}